import { render } from "./quiz3.vue?vue&type=template&id=3eb945cc&scoped=true"
import script from "./quiz3.vue?vue&type=script&lang=js"
export * from "./quiz3.vue?vue&type=script&lang=js"

import "./quiz3.vue?vue&type=style&index=0&id=3eb945cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb945cc"]])

export default __exports__